function formatMessageText(message){
    if(message){
      const index = message.lastIndexOf('*');
      return message.slice(index + 1,message.length);
     }
     return message;
}

export default formatMessageText;